import React, { useCallback, useState, useEffect } from "react";
import { useJsApiLoader } from "@react-google-maps/api";
import "../Map/Modal.css";
import Sidebar from "./Sidebar";
import MapView from "./MapView";

const libraries = ["places"];
const MapModal = ({ isOpen, profileOrigin, destination, onClose }) => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY,
    libraries,
  });

  const [response, setResponse] = useState(null);
  const [travelMode, setTravelMode] = useState("TRANSIT");
  const [routeIndex, setRouteIndex] = useState(0);
  const [editableDestination, setEditableDestination] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isCalculating, setIsCalculating] = useState(false);

const [origin, setOrigin] = useState({
  label: profileOrigin || "",   
  value: profileOrigin || ""    
});

const [availableModes, setAvailableModes] = useState({
  TRANSIT: true,
  DRIVING: true,
  WALKING: true,
  BICYCLING: true,
  TWO_WHEELER: true,
});
// const checkModeAvailability = (mode) => {
//   return new Promise((resolve) => {
//     const service = new window.google.maps.DirectionsService();

//     service.route(
//       {
//         origin: origin?.value,
//         destination: editableDestination,
//         travelMode: mode,
//       },
//       (result, status) => {
//         resolve(status === "OK");
//       }
//     );
//   });
// };

// useEffect(() => {
//   if (!origin?.value || !editableDestination || !window.google) return;

//   const modes = ["TRANSIT", "DRIVING", "WALKING", "BICYCLING", "TWO_WHEELER"];

//   const checkAll = async () => {
//     const result = {};

//     for (const mode of modes) {
//       result[mode] = await checkModeAvailability(mode);
//     }

//     setAvailableModes(result);
//   };

//   checkAll();
// }, [origin, editableDestination]);



  
const directionsCallback = useCallback(
  (res) => {
    setIsCalculating(false); 

    if (!res) return;

    if (res.status === "OK") {
      setErrorMessage("");
      setResponse(res);
    } else if (res.status === "ZERO_RESULTS") {
      setResponse(null);
      setErrorMessage("No route available for this mode.");
    }
  },
  [travelMode]
);




const changeMode = (mode) => {
  setIsCalculating(true);   
  setErrorMessage("");     
  setResponse(null);
  setRouteIndex(0);
  setTravelMode(mode);
};


  const handleSearch = () => {
    setResponse(null);
    setRouteIndex(0);
  };
  useEffect(() => {
    if (destination) {
      setEditableDestination(destination);
      setResponse(null);
      setRouteIndex(0);
    }
  }, [destination]);

  useEffect(() => {
  if (profileOrigin) {
    setOrigin({
      label: profileOrigin,
      value: profileOrigin
    });
    setResponse(null);
    setRouteIndex(0);
  }
}, [profileOrigin]);


  // 2️⃣ Destination change
  // useEffect(() => {
  //   if (destination) {
  //     setEditableDestination(destination);
  //     setResponse(null);
  //     setRouteIndex(0);
  //   }
  // }, [destination]);
useEffect(() => {
  if (
    response &&
    travelMode === "TRANSIT" &&
    response.request?.travelMode !== "TRANSIT"
  ) {
    alert("Public transport not available for this route. Showing driving route instead.");
  }
}, [response, travelMode]);
useEffect(() => {
  setTravelMode("TRANSIT");
}, []);

  if (!isOpen) return null;

  

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content-new" onClick={(e) => e.stopPropagation()}>
<button
  className="modal-close modal-close-mb"
  onClick={onClose}
>
          ×
        </button>

        {!isLoaded ? (
          <div className="modal-loading">Loading Maps...</div>
        ) : (
          <div className="modal-map-container">
            <Sidebar
              origin={origin}
              setOrigin={setOrigin}
              destination={editableDestination}
              setDestination={setEditableDestination}
              response={response}
              travelMode={travelMode}
              changeMode={changeMode}
              routeIndex={routeIndex}
              setRouteIndex={setRouteIndex}
              onSearch={handleSearch}
              errorMessage={errorMessage} 
              setResponse={setResponse}  
              availableModes={availableModes}
               isCalculating={isCalculating}
            />

            <div className="modal-map-view">
              <MapView
                origin={origin}
                destination={editableDestination}
                travelMode={travelMode}
                routeIndex={routeIndex}
                response={response}
                directionsCallback={directionsCallback}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MapModal;
